import apiFetch from '../apiFetch'

export default function (idAgenda, token) {
  return apiFetch({endPoint: `Agenda/deleteAgenda?idAgenda=` + idAgenda, method: 'GET', body: null, token: token})
}
